(() => {
  const selector = '[data-diy-dtf-configurator]';
  const rounded = (value) => Number(Number(value).toFixed(3));
  const init = (root) => {
    if (root.dataset.diyDtfReady === 'true') return;
    const form = root.closest('form');
    const idInput = form?.querySelector('input[name="id"]');
    const submitButton = form?.querySelector('button[name="add"]');
    if (!form || !idInput || !submitButton) return;
    root.dataset.diyDtfReady = 'true';
    const find = (key, scope = root) => scope.querySelector(`[data-diy-dtf-${key}]`);
    const cards = [...root.querySelectorAll('[data-diy-dtf-service-card]')];
    const sides = find('sides');
    const copies = find('quantity');
    const minimum = Math.max(1, Number(root.dataset.minimumOrderQuantity) || 1);
    const topPrice = form.closest('[data-section-id]')?.querySelector('.diy-main-product__price');
    let topPriceKey = '';
    let variants = [];
    try { variants = JSON.parse(find('variants').textContent); } catch (_) { /* Unavailable until valid product data is present. */ }
    let service = 'transfer';
    let nextId = 0;
    const designs = [];
    const money = (cents) => window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(cents, root.dataset.moneyFormat)
      : new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
    const salePrice = (variant) => Number(variant?.compare_at_price) > Number(variant?.price)
      ? Number(variant.price) : Math.round(Number(variant?.price) * 0.8);
    const selectedVariant = () => variants.find((v) => String(v.id) === String(service === 'transfer' ? cards[0].dataset.variantId : sides.value));
    const doubleSided = () => service === 'byo' && sides.selectedOptions[0]?.dataset.sides === 'double';
    const activeFaces = (design) => doubleSided() ? design.faces : design.faces.slice(0, 1);
    const countCopies = () => Number(copies.value);
    const goodCopies = () => Number.isSafeInteger(countCopies()) && countCopies() >= minimum;
    const error = (message = '') => {
      root.querySelectorAll('[aria-invalid]').forEach((input) => input.removeAttribute('aria-invalid'));
      find('error').textContent = message; find('error').hidden = !message;
    };
    const focus = (node) => { node?.scrollIntoView({ block: 'center' }); node?.focus({ preventScroll: true }); };
    const invalidate = (design) => {
      design.confirmed = false;
      find('design-status', design.node).textContent = 'Not confirmed';
      find('confirm', design.node).textContent = 'Confirm design';
      find('add-design').hidden = true;
      find('sticky-status').textContent = 'Confirm your designs';
    };

    function sync() {
      const variant = selectedVariant();
      const price = salePrice(variant);
      const nextPriceKey = `${variant?.id}:${price}:${variant?.compare_at_price}`;
      if (topPrice && topPriceKey !== nextPriceKey) {
        topPriceKey = nextPriceKey;
        const parts = variant ? [
          ['compare', money(Math.max(Number(variant.price), Number(variant.compare_at_price) || 0))],
          ['sale', money(price)], ['badge', '20% off'],
        ] : [['sale', 'Unavailable']];
        topPrice.replaceChildren(...parts.map(([kind, value]) => {
          const span = document.createElement('span');
          span.className = `diy-main-product__price-${kind}`;
          span.textContent = value;
          return span;
        }));
        topPrice.setAttribute('aria-live', 'polite');
      }
      const totalUnits = goodCopies() ? countCopies() * designs.length : 0;
      find('total-quantity').value = String(totalUnits);
      find('design-count').value = String(designs.length);
      const label = service === 'transfer' ? 'DTF Transfer Only' : `BYO Garments + Heat Press (${doubleSided() ? 'Double-Sided' : 'Single-Sided'} Print)`;
      find('service-property').value = label;
      find('selected-service').textContent = label;
      idInput.value = variant ? String(variant.id) : '';
      root.dataset.selectedVariantId = idInput.value;
      submitButton.disabled = !variant || variant.available === false;
      submitButton.textContent = !variant ? 'Unavailable' : variant.available === false ? 'Sold out' : 'Add to cart';
      find('byo-options').hidden = service !== 'byo';
      sides.disabled = service !== 'byo';
      find('quantity-label').textContent = doubleSided() ? 'Garments with each front + back pair' : 'Copies of each design';
      const unit = doubleSided() ? 'front + back pairs' : 'designs';
      find('charge-summary').textContent = `${designs.length} ${unit} × ${goodCopies() ? countCopies() : '—'} copies = ${totalUnits} ${service === 'byo' ? 'garments' : 'transfers'}. Every design ${doubleSided() ? 'pair ' : ''}is charged separately.`;
      find('unit-price').textContent = variant ? money(price) : '—';
      find('total-price').textContent = variant ? money(price * totalUnits) : '—';
      find('sticky-price').textContent = variant ? money(price * totalUnits) : '—';
      cards.forEach((card) => {
        const active = card.dataset.service === service;
        card.classList.toggle('is-selected', active);
        card.setAttribute('aria-pressed', String(active));
        find('service-state', card).textContent = active ? 'Selected' : 'Choose';
        const cardVariant = variants.find((v) => String(v.id) === String(card.dataset.service === 'transfer' ? card.dataset.variantId : sides.value));
        find('card-price', card).textContent = cardVariant ? `${money(salePrice(cardVariant))} each (20% off)` : 'Unavailable';
      });
      [...sides.options].forEach((option) => {
        const optionVariant = variants.find((v) => String(v.id) === option.value);
        if (optionVariant) option.textContent = `${option.dataset.sides === 'double' ? 'Double-sided' : 'Single-sided'} print — ${money(salePrice(optionVariant))} per garment (20% off)`;
      });
      designs.forEach((design, index) => {
        find('design-title', design.node).textContent = `Design ${index + 1}${doubleSided() ? ' — front + back pair' : ''}`;
        find('remove-design', design.node).hidden = designs.length === 1;
        find('design-subtotal', design.node).textContent = variant ? `${goodCopies() ? countCopies() : '—'} copies × ${money(price)} = ${money(price * (goodCopies() ? countCopies() : 0))}` : 'Service unavailable';
        const position = find('position', design.node);
        find('position-wrap', design.node).hidden = service !== 'byo' || doubleSided();
        position.disabled = service !== 'byo' || doubleSided();
        position.name = `properties[Design ${index + 1} Print Position]`;
        design.faces.forEach((face, faceIndex) => {
          const enabled = faceIndex === 0 || doubleSided();
          face.node.hidden = !enabled;
          // Disabled fieldsets keep a saved back file out of single-sided orders.
          face.node.disabled = !enabled;
          const prefix = `Design ${index + 1}${doubleSided() ? faceIndex ? ' Back' : ' Front' : ''}`;
          find('face-title', face.node).textContent = doubleSided() ? faceIndex ? 'Back artwork' : 'Front artwork' : 'Artwork';
          face.file.name = `properties[${prefix} Artwork File]`;
          find('size-property', face.node).name = `properties[${prefix} Print Size]`;
          find('size-property', face.node).value = `${rounded(face.widthCm)} × ${rounded(face.heightCm)} cm`;
          find('ratio-property', face.node).name = `properties[${prefix} Proportions]`;
          find('ratio-property', face.node).value = face.ratio && face.locked ? 'Original artwork ratio locked' : 'Customer-entered dimensions; please review';
          find('background', face.node).name = `properties[${prefix} Remove Background]`;
        });
      });
      const confirmed = designs.length > 0 && designs.every((design) => design.confirmed);
      find('add-design').hidden = !confirmed;
      find('sticky-status').textContent = confirmed ? 'Designs confirmed' : 'Confirm your designs';
    }

    function showDimensions(face) {
      const factor = face.unit.value === 'in' ? 2.54 : 1;
      face.width.value = face.widthCm ? String(rounded(face.widthCm / factor)) : '';
      face.height.value = face.heightCm ? String(rounded(face.heightCm / factor)) : '';
      face.width.max = String(35 / factor);
      face.height.max = String(45 / factor);
      face.width.min = face.height.min = String(1 / factor);
      find('width-label', face.node).textContent = `Width (${face.unit.value})`;
      find('height-label', face.node).textContent = `Height (${face.unit.value})`;
      face.lock.setAttribute('aria-pressed', String(!!face.ratio && face.locked));
      face.lock.disabled = !face.ratio;
      face.lock.textContent = !face.ratio ? 'Enter size manually' : face.locked ? 'Unlock proportions' : 'Lock proportions';
      if (face.ratio) find('ratio-status', face.node).textContent = face.locked
        ? 'Original image proportions locked. Adjust your desired print size below.'
        : 'Proportions unlocked. Width and height can be edited independently; our team will review the requested size.';
    }

    function makeFace(design, faceIndex) {
      const node = find('face-template').content.firstElementChild.cloneNode(true);
      const face = { node, file: find('artwork', node), width: find('width', node), height: find('height', node), unit: find('unit', node), lock: find('lock', node), widthCm: 0, heightCm: 0, ratio: null, locked: false, url: '', version: 0, loading: false };
      const prefix = `DiyDtf-${root.dataset.sectionId}-${design.id}-${faceIndex}`;
      [['file', face.file], ['width', face.width], ['height', face.height], ['unit', face.unit], ['background', find('background', node)]].forEach(([key, input]) => {
        input.id = `${prefix}-${key}`;
        find(`${key}-label`, node).htmlFor = input.id;
      });
      face.unit.addEventListener('change', () => { showDimensions(face); sync(); });
      [face.width, face.height].forEach((input) => input.addEventListener('input', () => {
        const factor = face.unit.value === 'in' ? 2.54 : 1;
        const value = Number(input.value) * factor;
        if (input === face.width) {
          face.widthCm = value;
          if (face.locked && face.ratio) { face.heightCm = value / face.ratio; face.height.value = String(rounded(face.heightCm / factor)); }
        } else {
          face.heightCm = value;
          if (face.locked && face.ratio) { face.widthCm = value * face.ratio; face.width.value = String(rounded(face.widthCm / factor)); }
        }
        invalidate(design); error(); sync();
      }));
      face.lock.addEventListener('click', () => {
        if (!face.ratio) return;
        face.locked = !face.locked;
        if (face.locked && face.widthCm) face.heightCm = face.widthCm / face.ratio;
        invalidate(design); showDimensions(face); sync();
      });
      find('background', node).addEventListener('change', () => { invalidate(design); sync(); });
      face.file.addEventListener('change', () => {
        const version = ++face.version;
        if (face.url) URL.revokeObjectURL(face.url);
        face.url = ''; face.ratio = null; face.locked = false; face.loading = false;
        const preview = find('preview', node);
        preview.hidden = true; preview.removeAttribute('src');
        invalidate(design); error(); showDimensions(face); sync();
        const file = face.file.files[0];
        const status = find('ratio-status', node);
        status.textContent = file ? 'Enter the finished width and height manually for this file.' : 'Upload a PNG or JPG to keep its original proportions. Enter sizes manually for other files.';
        // ponytail: preserve the live 4 MiB raster-preview ceiling; other files use manual dimensions.
        if (!file || file.size > 4 * 1024 * 1024 || !/\.(png|jpe?g|webp|gif)$/i.test(file.name)) return;
        const image = new Image();
        face.url = URL.createObjectURL(file);
        face.loading = true;
        status.textContent = 'Reading image proportions…';
        image.onload = () => {
          if (version !== face.version) return;
          face.loading = false;
          if (!image.naturalWidth || !image.naturalHeight) { status.textContent = 'Enter the finished width and height manually for this file.'; return; }
          face.ratio = image.naturalWidth / image.naturalHeight;
          face.locked = true;
          face.widthCm = face.widthCm > 0 ? face.widthCm : 10;
          face.heightCm = face.widthCm / face.ratio;
          const fit = Math.min(1, 35 / face.widthCm, 45 / face.heightCm);
          face.widthCm *= fit; face.heightCm *= fit;
          preview.src = face.url; preview.hidden = false;
          status.textContent = `Original image: ${image.naturalWidth} × ${image.naturalHeight} pixels. Proportions locked; adjust your desired print size below.`;
          showDimensions(face); sync();
        };
        image.onerror = () => { if (version === face.version) { face.loading = false; status.textContent = 'Image proportions could not be read. Enter both sizes manually.'; showDimensions(face); sync(); } };
        image.src = face.url;
      });
      find('faces', design.node).append(node);
      showDimensions(face);
      return face;
    }

    function validateDesign(design) {
      for (const face of activeFaces(design)) {
        if (!face.file.files.length) return { message: `Upload the ${doubleSided() && face === design.faces[1] ? 'back' : 'artwork'} file for each design.`, field: face.file };
        if (face.loading) return { message: 'Wait for the image proportions to finish loading.', field: face.file };
        if (!Number.isFinite(face.widthCm) || face.widthCm < 1 || face.widthCm > 35 + 0.00001) return { message: 'Enter a width of at least 1 cm and no more than 35 cm (about 0.394–13.78 in).', field: face.width };
        if (!Number.isFinite(face.heightCm) || face.heightCm < 1 || face.heightCm > 45 + 0.00001) return { message: 'Enter a height of at least 1 cm and no more than 45 cm (about 0.394–17.72 in).', field: face.height };
      }
      return null;
    }

    function addDesign() {
      const design = { id: ++nextId, node: find('design-template').content.firstElementChild.cloneNode(true), faces: [], confirmed: false };
      designs.push(design);
      find('designs').append(design.node);
      const position = find('position', design.node);
      position.id = `DiyDtf-${root.dataset.sectionId}-${design.id}-position`;
      find('position-label', design.node).htmlFor = position.id;
      position.addEventListener('change', () => { invalidate(design); sync(); });
      design.faces = [makeFace(design, 0), makeFace(design, 1)];
      find('confirm', design.node).addEventListener('click', () => {
        const invalid = validateDesign(design);
        if (invalid) { error(invalid.message); invalid.field.setAttribute('aria-invalid', 'true'); focus(invalid.field); return; }
        design.confirmed = true;
        find('design-status', design.node).textContent = 'Confirmed';
        find('confirm', design.node).textContent = 'Design confirmed';
        error(); sync();
      });
      find('remove-design', design.node).addEventListener('click', () => {
        if (designs.length <= 1) return;
        design.faces.forEach((face) => { ++face.version; if (face.url) URL.revokeObjectURL(face.url); });
        designs.splice(designs.indexOf(design), 1);
        design.node.remove(); error(); sync(); focus(find('confirm', designs[0].node));
      });
      sync();
      return design;
    }

    cards.forEach((card) => card.addEventListener('click', () => {
      if (service === card.dataset.service) return;
      service = card.dataset.service;
      designs.forEach(invalidate); error(); sync();
    }));
    sides.addEventListener('change', () => { designs.forEach(invalidate); error(); sync(); });
    copies.addEventListener('input', sync);
    copies.addEventListener('change', sync);
    find('add-design').addEventListener('click', () => { const design = addDesign(); error(); focus(design.faces[0].file); });
    find('sticky-action').addEventListener('click', () => {
      const design = designs.find((item) => !item.confirmed);
      focus(design ? design.faces[0].file : submitButton);
    });
    function validateOrder(event) {
      sync();
      const variant = selectedVariant();
      let invalid = !variant || variant.available === false ? { message: 'This print service is unavailable. Choose another service.', field: cards[0] } : null;
      if (!invalid && !goodCopies()) invalid = { message: `Enter a whole number of copies, at least ${minimum}.`, field: copies };
      if (!invalid && !Number.isSafeInteger(countCopies() * designs.length)) invalid = { message: 'The total quantity is too large. Contact our team for this order.', field: copies };
      for (const design of designs) {
        if (invalid) break;
        invalid = validateDesign(design) || (!design.confirmed ? { message: 'Confirm every design before adding to cart.', field: find('confirm', design.node) } : null);
      }
      if (!invalid) { error(); return; }
      event.preventDefault(); event.stopImmediatePropagation(); error(invalid.message); invalid.field.setAttribute('aria-invalid', 'true'); focus(invalid.field);
    }
    submitButton.addEventListener('click', validateOrder, true);
    // Validate before the theme's document-level native-file-submit guard stops propagation.
    window.addEventListener('submit', (event) => { if (event.target === form && root.isConnected) validateOrder(event); }, true);
    addDesign();
    find('script-guard').disabled = true;
    form.noValidate = true;
  };
  const initAll = (scope = document) => scope.querySelectorAll(selector).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
